module.exports = __webpack_public_path__ + "img/vs-img.8e5eef83.png";